import { ERentioFormField } from "../../components/components/Form";
import { getName } from "../../redux/contact/contact.utils";
import { getValue } from "../../redux/form/form.utils";
import { startOfDay, endOfDay, isEqual, isBefore, isAfter, } from "../../utils/date-fns.utils";
import { formatDate } from "../../utils/date.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { getMappedCountries } from "../../utils/location/location.utils";
import { EBanqupRentioDocumentType, EField, } from "./schema.createRentDeposit.types";
import { getForeignersForBanqup, getIdDocumentsSummary, getNavigationTitle, getPayerForBanqup, isFileSizeValid, } from "./schema.createRentDeposit.utils";
var NOW = new Date();
var END_OF_DAY = endOfDay(NOW);
export var getSchema = function (initialValues, extraData) {
    return function (defaultValues) {
        var _a, _b, _c;
        var selectedPayer = getPayerForBanqup(defaultValues, extraData);
        var foreigners = getForeignersForBanqup(initialValues, defaultValues, extraData);
        var requiredFields = [EField.PayerIdentityDocuments];
        if (foreigners.length > 0) {
            requiredFields.push(EField.BanqupIdentityDocuments);
        }
        return {
            required: requiredFields,
            properties: (_a = {},
                _a[EField.Header + "8"] = {
                    default: undefined,
                },
                _a[EField.PayerIdentityDocuments] = {
                    // @ts-ignore
                    default: (function () {
                        var _a;
                        return [
                            (_a = {},
                                _a[EField.PayerIdentityDocumentAccountId] = selectedPayer === null || selectedPayer === void 0 ? void 0 : selectedPayer.id,
                                _a[EField.DocumentType] = EBanqupRentioDocumentType.IdCard,
                                _a.contact = selectedPayer,
                                _a),
                        ];
                    })(),
                    type: "array",
                    items: {
                        type: "object",
                        required: [
                            EField.IdentityDocumentIdentityFrontDocumentId,
                            EField.IdentityDocumentIdentityBackDocumentId,
                            EField.DateOfExpiry,
                            EField.DocumentNumber,
                            EField.DateOfIssuance,
                            EField.CountryOfIssuance,
                        ],
                        properties: (_b = {},
                            _b[EField.PayerIdentityDocumentAccountId] = {},
                            _b[EField.DocumentType] = {
                                default: EBanqupRentioDocumentType.IdCard,
                                // @ts-ignore
                                options: [
                                    EBanqupRentioDocumentType.IdCard,
                                    EBanqupRentioDocumentType.Passport,
                                ].map(function (id) { return ({
                                    id: id,
                                    value: getLocalizedText("rent_deposit.documentType.".concat(id.toLowerCase())),
                                }); }),
                            },
                            _b[EField.IdentityDocumentIdentityFrontDocumentId] = {
                                minLength: 1,
                            },
                            _b[EField.IdentityDocumentIdentityBackDocumentId] = {
                                minLength: 1,
                            },
                            _b[EField.DocumentNumber] = {
                                default: getValue(EField.DocumentNumber, initialValues, defaultValues),
                            },
                            _b[EField.DateOfIssuance] = {
                                default: getValue(EField.DateOfIssuance, initialValues, defaultValues),
                            },
                            _b[EField.DateOfExpiry] = {
                                default: getValue(EField.DateOfExpiry, initialValues, defaultValues),
                            },
                            _b[EField.CountryOfIssuance] = {
                                default: getValue(EField.CountryOfIssuance, initialValues, defaultValues),
                                // @ts-ignore
                                options: getMappedCountries(),
                            },
                            _b),
                    },
                    uniqueItems: true,
                },
                _a[EField.Header + "9"] = {
                    default: undefined,
                    showIf: function (_) { return foreigners.length > 0; },
                },
                _a[EField.BanqupIdentityDocuments] = {
                    // @ts-ignore
                    default: foreigners,
                    showIf: function (_) { return foreigners.length > 0; },
                    type: "array",
                    items: {
                        type: "object",
                        required: [
                            EField.IdentityDocumentIdentityFrontDocumentId,
                            EField.IdentityDocumentIdentityBackDocumentId,
                        ],
                        properties: (_c = {},
                            _c[EField.IdentityDocumentAccountId] = {},
                            _c[EField.IdentityDocumentIdentityFrontDocumentId] = {
                                minLength: 1,
                            },
                            _c[EField.IdentityDocumentIdentityBackDocumentId] = {
                                minLength: 1,
                            },
                            _c),
                    },
                    uniqueItems: true,
                },
                _a),
        };
    };
};
export var uiSchema = function (extraData) {
    var _a, _b, _c;
    return _a = {
            "rentio:title": getLocalizedText("rent_deposit.identity_documents.heading.summary"),
            "rentio:navigationTitle": getNavigationTitle(extraData)
        },
        _a[EField.Header + "8"] = {
            "ui:field": ERentioFormField.SectionHeader,
            title: getLocalizedText("rent_deposit.banqup_identity_documents.heading"),
        },
        _a[EField.PayerIdentityDocuments] = {
            "ui:field": ERentioFormField.Array,
            title: getLocalizedText("rent_deposit.banqup_identity_documents.heading"),
            "ui:options": {
                orderable: false,
                addable: false,
                removable: false,
            },
            getItemTitle: function (itemData) {
                return itemData.contact && getName(itemData.contact);
            },
            items: (_b = {},
                _b[EField.PayerIdentityDocumentAccountId] = { "ui:widget": "hidden" },
                _b[EField.DocumentType] = {
                    "ui:field": ERentioFormField.SegmentedControl,
                    title: getLocalizedText("rent_deposit.documentType.label"),
                    formatSummary: function (formData) {
                        return getLocalizedText("rent_deposit.documentType.".concat(formData === null || formData === void 0 ? void 0 : formData.toLowerCase()));
                    },
                },
                _b[EField.IdentityDocumentIdentityFrontDocumentId] = {
                    "ui:field": ERentioFormField.DocumentSelectInline,
                    formatSummary: function (formData) {
                        return formData === null || formData === void 0 ? void 0 : formData.map(function (doc) { return doc.name; }).join(", ");
                    },
                    accept: ["image/jpeg", "image/jpg"],
                    multiple: false,
                    title: getLocalizedText("rent_deposit.identity_documents.front_document.label"),
                },
                _b[EField.IdentityDocumentIdentityBackDocumentId] = {
                    "ui:field": ERentioFormField.DocumentSelectInline,
                    formatSummary: function (formData) {
                        return formData === null || formData === void 0 ? void 0 : formData.map(function (doc) { return doc.name; }).join(", ");
                    },
                    accept: ["image/jpeg", "image/jpg"],
                    multiple: false,
                    title: getLocalizedText("rent_deposit.identity_documents.back_document.label"),
                },
                _b[EField.DateOfExpiry] = {
                    "ui:field": ERentioFormField.Date,
                    title: getLocalizedText("rent_deposit.id_expiry_date.label"),
                    formatSummary: function (input) { return input && formatDate(input); },
                },
                _b[EField.DocumentNumber] = {
                    "ui:field": ERentioFormField.Text,
                    title: getLocalizedText("rent_deposit.document_number.label"),
                },
                _b[EField.CountryOfIssuance] = {
                    "ui:field": ERentioFormField.DropdownSelect,
                    title: getLocalizedText("rent_deposit.country_of_issuance.label"),
                },
                _b[EField.DateOfIssuance] = {
                    "ui:field": ERentioFormField.Date,
                    title: getLocalizedText("rent_deposit.date_of_issuance.label"),
                    formatSummary: function (input) { return input && formatDate(input); },
                },
                _b),
            formatSummary: function (docs) { return getIdDocumentsSummary(docs); },
        },
        _a[EField.Header + "9"] = {
            "ui:field": ERentioFormField.SectionHeader,
            title: getLocalizedText("rent_deposit.identity_documents.heading"),
        },
        _a[EField.BanqupIdentityDocuments] = {
            "ui:field": ERentioFormField.Array,
            title: getLocalizedText("rent_deposit.identity_documents.heading"),
            "ui:options": {
                orderable: false,
                addable: false,
                removable: false,
            },
            getItemTitle: function (itemData) {
                return itemData.contact && getName(itemData.contact);
            },
            items: (_c = {},
                _c[EField.IdentityDocumentAccountId] = { "ui:widget": "hidden" },
                _c[EField.IdentityDocumentIdentityFrontDocumentId] = {
                    "ui:field": ERentioFormField.DocumentSelectInline,
                    formatSummary: function (formData) {
                        return formData === null || formData === void 0 ? void 0 : formData.map(function (doc) { return doc.name; }).join(", ");
                    },
                    accept: ["image/*"],
                    multiple: false,
                    title: getLocalizedText("rent_deposit.identity_documents.front_document.label"),
                },
                _c[EField.IdentityDocumentIdentityBackDocumentId] = {
                    "ui:field": ERentioFormField.DocumentSelectInline,
                    formatSummary: function (formData) {
                        return formData === null || formData === void 0 ? void 0 : formData.map(function (doc) { return doc.name; }).join(", ");
                    },
                    accept: ["image/*"],
                    multiple: false,
                    title: getLocalizedText("rent_deposit.identity_documents.back_document.label"),
                },
                _c),
            formatSummary: function (docs) { return getIdDocumentsSummary(docs); },
        },
        _a;
};
export var getValidate = function () { return function (formData, errors) {
    var allowedMBS = 10;
    var _a = formData, _b = EField.BanqupIdentityDocuments, _c = _a[_b], banqupIdentityDocuments = _c === void 0 ? [] : _c, _d = EField.PayerIdentityDocuments, _e = _a[_d], payerIdentityDocuments = _e === void 0 ? [] : _e;
    if (banqupIdentityDocuments.length > 0) {
        banqupIdentityDocuments.forEach(function (document, index) {
            var _a = document.identityBackDocument, identityBackDocument = _a === void 0 ? [] : _a, _b = document.identityFrontDocument, identityFrontDocument = _b === void 0 ? [] : _b;
            var _c = (errors[EField.BanqupIdentityDocuments] || [])[index] || {}, identityBackDocumentError = _c.identityBackDocument, identityFrontDocumentError = _c.identityFrontDocument;
            if (identityFrontDocument.length > 0) {
                if (!isFileSizeValid(identityFrontDocument[0], allowedMBS)) {
                    identityFrontDocumentError.addError(getLocalizedText("form.create_rent_deposit.banqup_id_doc.max_file_size.error", { fileSize: "10MB" }));
                }
            }
            if (identityBackDocument.length > 0) {
                if (!isFileSizeValid(identityBackDocument[0], allowedMBS)) {
                    identityBackDocumentError.addError(getLocalizedText("form.create_rent_deposit.banqup_id_doc.max_file_size.error", { fileSize: "10MB" }));
                }
            }
        });
    }
    if (payerIdentityDocuments.length > 0) {
        var _f = payerIdentityDocuments[0], _g = _f.identityBackDocument, identityBackDocument = _g === void 0 ? [] : _g, _h = _f.identityFrontDocument, identityFrontDocument = _h === void 0 ? [] : _h, dateOfIssuance = _f.dateOfIssuance, dateOfExpiry = _f.dateOfExpiry;
        var _j = (errors[EField.PayerIdentityDocuments] || [])[0] || {}, dateOfIssuanceError = _j.dateOfIssuance, dateOfExpiryError = _j.dateOfExpiry, identityBackDocumentError = _j.identityBackDocument, identityFrontDocumentError = _j.identityFrontDocument;
        if (identityFrontDocument.length > 0) {
            if (!isFileSizeValid(identityFrontDocument[0], allowedMBS)) {
                identityFrontDocumentError.addError(getLocalizedText("form.create_rent_deposit.banqup_id_doc.max_file_size.error", { fileSize: "10MB" }));
            }
        }
        if (identityBackDocument.length > 0) {
            if (!isFileSizeValid(identityBackDocument[0], allowedMBS)) {
                identityBackDocumentError.addError(getLocalizedText("form.create_rent_deposit.banqup_id_doc.max_file_size.error", { fileSize: "10MB" }));
            }
        }
        if (isAfter(dateOfIssuance, END_OF_DAY) && dateOfIssuanceError) {
            dateOfIssuanceError.addError(getLocalizedText("form.create_rent_deposit.payer_id_doc.date_of_issue.error"));
            return errors;
        }
        if (isEqual(startOfDay(dateOfExpiry), startOfDay(dateOfIssuance)) &&
            dateOfExpiryError &&
            dateOfIssuanceError) {
            dateOfExpiryError.addError(getLocalizedText("form.create_rent_deposit.payer_id_doc.date_of_expiry_same_as_date_of_issuance.error"));
            return errors;
        }
        if (isBefore(dateOfExpiry, dateOfIssuance) && dateOfExpiryError) {
            dateOfExpiryError.addError(getLocalizedText("form.create_rent_deposit.payer_id_doc.date_of_expiry_before_date_of_issuance.error"));
        }
        return errors;
    }
    return errors;
}; };
